import { Rule } from "@siteimprove/alfa-act";
import { audio } from "../common/applicability/audio.js";
import { audioTextAlternative } from "../common/expectation/media-text-alternative.js";
import { Scope, Stability } from "../tags/index.js";
export default Rule.Atomic.of({
    uri: "https://alfa.siteimprove.com/rules/sia-r29",
    tags: [Scope.Component, Stability.Stable],
    evaluate({ device, document }) {
        return {
            applicability() {
                return audio(document, device);
            },
            expectations(target) {
                return audioTextAlternative(target, device);
            },
        };
    },
});
//# sourceMappingURL=rule.js.map